import { Box } from "@repo/components/src/ui/box";
import { HStack } from "@repo/components/src/ui/hstack";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import formatBytesToHuman from "@repo/components/src/utils/bytes";
import { ExternalPathString, Link } from "expo-router";
import { Download, FileText } from "lucide-react-native";
import { PdfViewerProps } from "./types";

export default function PdfViewer(props: PdfViewerProps) {
  const isRight = props.position === "right";
  const fileName = props.uri.name.split("/").pop() || props.uri.name;
  const size = props.uri.fileSize
    ? formatBytesToHuman(props.uri.fileSize)
    : null;

  const tileClass = isRight
    ? "bg-background-0/15 border border-background-0/20"
    : "bg-brand-50 border border-brand-100";
  const iconClass = isRight ? "text-background-0" : "text-brand-600";
  const titleClass = isRight ? "text-background-0" : "text-typography-900";
  const subClass = isRight ? "text-background-0/70" : "text-typography-500";
  const downloadBtnClass = isRight
    ? "bg-background-0/20 text-background-0"
    : "bg-background-100 text-typography-700";

  return (
    <Link
      href={props.uri.uri as ExternalPathString}
      target="_blank"
      rel="noreferrer"
      className="group/pdf-link"
    >
      <HStack
        space="sm"
        className="items-center min-w-[260px] max-w-sm py-1 pr-1"
      >
        <Box className={`p-3 rounded-xl ${tileClass}`}>
          <Icon as={FileText} className={`w-6 h-6 ${iconClass}`} />
        </Box>
        <VStack className="flex-1 shrink min-w-0" space="xs">
          <Text
            size="sm"
            bold
            className={`${titleClass} group-hover/pdf-link:underline`}
            isTruncated
            numberOfLines={1}
          >
            {fileName}
          </Text>
          <HStack space="xs" className="items-center">
            <Text
              size="2xs"
              className={`${subClass} uppercase tracking-wider`}
              bold
            >
              PDF
            </Text>
            {size && (
              <>
                <Box
                  className={`w-0.5 h-0.5 rounded-full ${
                    isRight ? "bg-background-0/50" : "bg-typography-400"
                  }`}
                />
                <Text size="2xs" className={subClass}>
                  {size}
                </Text>
              </>
            )}
          </HStack>
        </VStack>
        <Box className={`p-2 rounded-lg ${downloadBtnClass}`}>
          <Icon as={Download} className="w-4 h-4" />
        </Box>
      </HStack>
    </Link>
  );
}
